import classNames from 'classnames';
import React from 'react';
import { Tooltip } from '@meitu/saas-ui';
import IconFont from '@meitu/xdesign-icon-font';
import { useEditor } from '@/hooks/use-editor';
import { useLocaleStore } from '@/i18n';
import { ICallback, IToolLayout } from '../../types';

const DeleteBtn = ({
    id,
    disable = false,
    onDelete,
    beforeDelete,
}: Pick<IToolLayout & ICallback, 'disable' | 'onDelete' | 'id' | 'beforeDelete'>) => {
    const { $t } = useLocaleStore();
    const editor = useEditor();

    return (
        <Tooltip placement="bottom" title={$t((v) => v.headerToolbar.deleteBtn.delText)}>
            <div
                className={classNames('c-header-toolbar-actions-btn', {
                    disable,
                })}
                onClick={() => {
                    if (disable) return;
                    if (beforeDelete?.()) return;
                    editor.layer.delete(id);
                    onDelete?.();
                }}
            >
                <IconFont fontSize={14} name="TrashCanBold" />
            </div>
        </Tooltip>
    );
};

export default React.memo(DeleteBtn);
